import { useEffect, useState } from "react";
import { api, inr } from "@/lib/api";

export default function AdminCustomers() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/admin/customers").then((r) => setRows(r.data)); }, []);
  const filtered = rows.filter((c) => !q || c.name?.toLowerCase().includes(q.toLowerCase()) || c.email.includes(q.toLowerCase()));
  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between flex-wrap gap-3"><h1 className="text-2xl font-bold">Customers <span className="text-slate-400 text-base">({rows.length})</span></h1>
        <input data-testid="cust-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search…" className="px-3 py-2 bg-white border border-slate-300 rounded-lg text-sm w-48" /></div>
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-x-auto">
        <table className="w-full text-sm min-w-[560px]">
          <thead><tr className="text-xs font-bold uppercase tracking-wider text-slate-500 bg-slate-50"><th className="text-left py-3 px-4">Name</th><th className="text-left py-3 px-4">Email</th><th className="text-left py-3 px-4">Phone</th><th className="text-center py-3 px-4">Orders</th><th className="text-right py-3 px-4">Spent</th></tr></thead>
          <tbody>{filtered.map((c) => (
            <tr key={c.id} data-testid={`customer-${c.id}`} className="border-b border-slate-50 hover:bg-slate-50">
              <td className="py-2.5 px-4 font-semibold">{c.name}</td><td className="py-2.5 px-4 text-slate-500">{c.email}</td><td className="py-2.5 px-4">{c.phone || "—"}</td>
              <td className="py-2.5 px-4 text-center font-bold">{c.order_count}</td><td className="py-2.5 px-4 text-right font-semibold">{inr(c.total_spent)}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
}
